import { useParams } from 'react-router';
import { LeadDetailBody } from './LeadDetailBody';

export function LeadDetailView() {
  const { id } = useParams<{ id: string }>();
  return <LeadDetailBody id={id ?? ''} />;
}
